<div class="chart-wrapper" *ngIf="trends?.length && trendsFiltered.length">
  <div *ngIf="chartOptions?.series?.length">
    <h2 data-at-trending-chart-name>{{ name }}</h2>

    <highcharts-chart
      class="highchart"
      [Highcharts]="highCharts"
      [options]="chartOptions"
      (chartInstance)="getChartInstance($event)"
      [oneToOne]="true"
    ></highcharts-chart>
    <div #customLegendContainer></div>
  </div>
</div>
